export default __webpack_public_path__ + "assets/Compare8.png";